module.exports = __webpack_public_path__ + "img/img_3.97d3999a.jpeg";